import { render, staticRenderFns } from "./ctable.vue?vue&type=template&id=f4b8f588&scoped=true&"
import script from "./ctable.vue?vue&type=script&lang=js&"
export * from "./ctable.vue?vue&type=script&lang=js&"
import style0 from "./ctable.vue?vue&type=style&index=0&id=f4b8f588&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4b8f588",
  null
  
)

export default component.exports